module.exports = __webpack_public_path__ + "img/handraw_quitter orange-44.69cf5941.svg";